import { FC, useMemo } from 'react';

import { Logs } from 'utils/types';
import { dayjs } from 'utils/providers/Timezone';

import ActivityDetails from './ActivityDetails';
import ActivityLog from './ActivityLog';

const ActivitiesEntry: FC<{ data: Logs }> = ({ data }) => {
  const title = useMemo(() => {
    const logs = ActivityLog[data.source][data.action];

    if (!logs || !logs.title) return '---';

    return logs.title;
  }, [data]);

  return (
    <div className="relative text-left py-[18px]">
      <h4 className="label text-left text-[14px] font-semibold leading-[20px]">
        {title}
      </h4>
      <div>
        <ActivityDetails data={data} />
      </div>
      <p className="block whitespace-pre-line text-[12px]">
        {dayjs(data?.createdAt).format('MMM DD, YYYY')} at{' '}
        {dayjs(data?.createdAt).format('hh:mm:ss A')}
      </p>
    </div>
  );
};

export default ActivitiesEntry;
